import React from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import {
  FDStack, FDImage, FDAvatar, FDPaper, FDBodyText, FDTitleText,
} from '@facet-wealth/design';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import useScrollTopOnMount from 'Hooks/useScrollTopOnMount';
import useEventTrackingLogEvent, { categories, eventSubTypes, eventTypes } from 'EventTracking/useEventTrackingLogEvent';
import StepNavigationFooter from 'Packages/FacetDesign/Components/Experimental/StepNavigationFooter';
import { dataAttrs } from 'Helpers/Testing';
import {
  useBuildCommonFQEventProperties,
} from 'Views/FreemiumEntry/HasRelationship/Content/Components/utils';
import useBoneBackgroundColor from 'Hooks/useBoneBackgroundColor';
import { QuizWrapperLayout } from 'Views/FreemiumEntry/HasRelationship/Content/Components/QuizWrapperLayout';
import fr from 'facet-rest';
import { LottieLoadingLayout } from 'Organisms/LottieControl/LottieLoadingLayout';
import { LottieRel } from 'Packages/FacetCore/Experimental/RelationshipComponents/LottieRel';
import { ProgressBar } from 'Views/FreemiumEntry/HasRelationship/Content/Templates/PicklistQuestion/ProgressBar';

const InsightSocialProof = () => {
  const { resource, onSubmit, saving } = useMetaLayoutContext();
  const { logStandardizedEvent } = useEventTrackingLogEvent();
  const { buildCommonFQEventProperties } = useBuildCommonFQEventProperties();

  useScrollTopOnMount();

  useBoneBackgroundColor();

  return (
    <QuizWrapperLayout>
      <FDStack direction={'column'} spacing={4} {...dataAttrs('insight-container')}>
        <ProgressBar />
        <FDStack direction={'column'} spacing={4}>
          <LottieLoadingLayout>
            <FDStack direction={'column'} spacing={4}>
              <FDStack direction={'column'} spacing={2} alignItems={'center'}>
                {resource.withRelationship(fr.relationships.avatar.name,
                  (rel) => (
                    <FDStack direction={'column'} alignItems={'center'} paddingY={2}>
                      <FDAvatar
                        src={rel.link('related').url()}
                        alt={rel.meta('altText') || ''}
                        size={rel.meta('avatarSize')}
                      />
                    </FDStack>),
                  () => null)}
                {resource.withRelationship(fr.relationships.headerImage.name,
                  (rel) => (
                    <FDImage
                      src={rel.link('related').url()}
                      alt={rel.meta('altText') || ''}
                      aspectRatio={rel.meta('aspectRatio')}
                      width={'100%'}
                      maxWidth={360}
                    />),
                  () => null)}
                <LottieRel relationship={resource.relationship(fr.relationships.lottie.name)} width={300} />
                <MetaControlField attr={'insightTitle'} />
                <MetaControlField attr={'insightDescription'} />
                {resource.withRelationship(fr.relationships.image.name,
                  (rel) => (
                    <FDImage
                      src={rel.link('related').url()}
                      alt={rel.meta('altText') || ''}
                      aspectRatio={rel.meta('aspectRatio')}
                      width={'100%'}
                    />),
                  () => null)}
                {resource.withRelationship(fr.relationships.testimonialImage.name,
                  (rel) => (
                    <FDPaper padding={3} appearance={'elevated'}>
                      <FDStack direction={'column'} spacing={2}>
                        <FDStack spacing={2} alignItems={'center'}>
                          <FDAvatar
                            src={rel.link('related').url()}
                            alt={rel.meta('altText') || ''}
                            size={rel.meta('avatarSize')}
                          />
                          <FDTitleText color={'textSecondary'} value={rel.meta('title')} size={'lg'} />
                        </FDStack>
                        <FDBodyText value={rel.meta('description')} />
                      </FDStack>
                    </FDPaper>),
                  () => null)}
              </FDStack>
            </FDStack>
          </LottieLoadingLayout>
        </FDStack>
        {resource.meta().canPut() && <StepNavigationFooter
          onNext={() => {
            logStandardizedEvent(categories.facetQuiz, eventTypes.insight, eventSubTypes.clickedCTA, {
              eventProperties: {
                ...buildCommonFQEventProperties(resource),
                insightId: resource.attr('insightId'),
                insightReferenceName: resource.attr('insightReferenceName'),
              },
            });
            onSubmit();
          }}
          isLoading={saving}
          label={resource.attr('primaryActionLabel') || 'Continue'}
        />}
      </FDStack>
    </QuizWrapperLayout>
  );
};

export { InsightSocialProof };
